import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormSectionProps } from "../../../../../models/form-section.model";
import { ScenarioModel } from "../../../../../models/scenario.model";
import { VALIDATION_UTIL } from "../../../../../utils/validation.utils";
import { InfoCircleIcon } from "../../../../atoms/icon";
import PercentInput from "../../../../atoms/percent-input";




const EstimateLikelihoodSection = (props: FormSectionProps<ScenarioModel>) => {

    const { t } = useTranslation();

    return (
        <div className="section-wrapper">
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbLikelihood")}
                        name="likelihood"
                        tooltip={{ title: t("Scenario.lbLikelihood"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("likelihood", props.requiredFields)}
                    >
                        <PercentInput />
                    </Form.Item>
                </Col>

            </Row>


        </div>
    )
}

export default EstimateLikelihoodSection;